import {deleteAnalysisSteps} from 'analysis-tool/AnalysisActions';
import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {checkCanModifyStep} from 'analysis-tool/EditStepHelpers';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {recordAnalysisAction} from 'analysis-tool/ui/debugAnalysisActionHistory';
import {DeletePipelineStepsBehavior} from 'pipelines/network/PipelineDAO';
import runConfirmDeleteModal from 'ui-library/modals/runConfirmDeleteModal';
import {withLoadingScreen} from 'util/Promises';

export default function getDeleteViewAction(
  analysis: AnalysisGraphQL,
  view: AnalysisViewGraphQL,
  analysisClientStateId: string
): OverflowDataViewAction | null {
  if (isAnalysisReadOnly(analysis)) {
    return null;
  }

  const firstStep = view.lineage[0].step;
  const {canEdit, message} = checkCanModifyStep(analysis, firstStep.id, 'view', true);

  return {
    icon: 'delete',
    onClick: async () => {
      const confirmed = await runConfirmDeleteModal({typeName: 'view'});
      if (!confirmed) {
        return;
      }
      recordAnalysisAction('DELETE_VIEW', {
        analysisId: analysis.id,
        stepId: firstStep.id,
        firstStepType: firstStep.stepType,
      });
      return withLoadingScreen(
        deleteAnalysisSteps(
          analysis,
          {
            stepIds: [firstStep.id],
            behavior: DeletePipelineStepsBehavior.DELETE_ALL_CHILDREN,
          },
          analysisClientStateId
        )
      );
    },
    label: `Delete view`,
    isDisabled: !canEdit,
    helpText: !canEdit ? message : undefined,
  };
}
